import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { gql } from 'graphql-tag';
import { specificResourceAllocationFragment } from '~/modules/resourcing/common/fragments';

export const MERGE_RESOURCE_ALLOCATION = gql`
  mutation MergeResourceAllocation(
    $allocationId: String!
    $existingAllocationId: String!
  ) {
    mergeResourceAllocation(
      allocationId: $allocationId
      existingAllocationId: $existingAllocationId
    ) {
      resourceAllocation {
        id
        startDate
        endDate
        scheduleRules {
          dateRange {
            startDate
            endDate
          }
          do
        }
      }
    }
  }
`;

const useMergeResourceAllocation = () => {
  const [mergeResourceAllocation, { data, loading }] = useMutation(
    MERGE_RESOURCE_ALLOCATION
  );

  const onMergeResourceAllocation = useCallback(
    ({ allocationId, existingAllocationId }) =>
      mergeResourceAllocation({
        variables: {
          allocationId,
          existingAllocationId
        },
        update: updateCache({
          allocationId
        })
      }),
    [mergeResourceAllocation]
  );

  return {
    onMergeResourceAllocation,
    loading,
    data
  };
};

export const updateCache = ({ allocationId }) => proxy => {
  const fragment = {
    id: `ResourceAllocation:{"id":"${allocationId}"}`,
    fragment: specificResourceAllocationFragment,
    fragmentName: 'SpecificResourceAllocation'
  };
  const allocation = proxy.readFragment(fragment);

  if (allocation) {
    proxy.evict(fragment);
  }
};

export default useMergeResourceAllocation;
